import { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import { ListBox } from 'primereact/listbox'

import OverlayPanel from '@aytm/app/stats/components/overlay-panel/OverlayPanel'

// styles
import style from '@aytm/app/stats/components/images-dropdown/styles/ImagesDropdown.module.scss'

const ImagesDropdown = ({ image, options, disabled, onImageChange }) => {
  const ref = useRef(null)

  const imageObj = useMemo(() => (image ? options.find(item => item.key == image) : null), [image, options])

  const itemTemplate = option => (
    <span className={style.label}>
      {option ? (
        <>
          {option.src && <img width="23" height="23" src={option.src} alt="" />}
          <span dangerouslySetInnerHTML={{ __html: option.text }}></span>
        </>
      ) : (
        <i className="icon-aytmfd-image" />
      )}
    </span>
  )

  const onImageChangeClick = event => {
    onImageChange(event.value)

    ref.current.hide()
  }

  return 0 < options.length ? (
    <div className={classNames(style.images, { [style['images-disabled']]: disabled })}>
      {disabled ? (
        <span className={style.icon}>
          {imageObj && imageObj.src ? (
            <img width="23" height="23" src={imageObj.src} alt="" />
          ) : (
            <i className="icon-aytmfd-image" />
          )}
        </span>
      ) : (
        <OverlayPanel
          ref={ref}
          testId="stat-images-dropdown-button"
          button={
            <span className={style.icon}>
              {imageObj && imageObj.src ? (
                <img width="23" height="23" src={imageObj.src} alt="" />
              ) : (
                <i className="icon-aytmfd-image" />
              )}
            </span>
          }
        >
          <ListBox
            options={options}
            optionLabel="text"
            optionValue="key"
            itemTemplate={itemTemplate}
            listStyle={{ maxHeight: '250px' }}
            onChange={onImageChangeClick}
          />
        </OverlayPanel>
      )}
    </div>
  ) : null
}

ImagesDropdown.propTypes = {
  image: PropTypes.string,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  onImageChange: PropTypes.func
}

export default ImagesDropdown
